<template>
    <modal :cancel-button-text="$t('CONFIRM_MODAL_UNDERSTOOD')" class="text-center" custom-class="max-w-lg" v-if="nextDeliveryDay">
        <p>
            {{ $t('HOLIDAY_CANCELLATION_MODAL_NEXT_DELIVERY') }}
            <br><em><strong v-text='nextDeliveryDay'></strong></em>
        </p>
        <p v-html="$t('HOLIDAY_CANCELLATION_MODAL_LONGER_BREAK')"></p>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDate } from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import Modal from '@/components/structure/Modal';

export default {
    name: 'HolidayCancellationModal',
    components: {
        Modal,
    },
    computed: {
        ...mapGetters({
            deliveries: 'scheduledOrder/getDeliveries',
        }),
        nextDeliveryDay() {
            let firstDelivery = this.deliveries.find((item) => item.delivery_scheduled);
            return firstDelivery ? formatDate(firstDelivery.datetime, Dates.DAY_DATE_OF_MONTH) : null;
        },
    },
};
</script>
